<app-loading></app-loading>
<div class="page-wraper full">
  <!-- header -->
  <app-header1 [data]="profile"></app-header1>
  <!-- header END -->
  <app-page-banner [data]="page_banner"></app-page-banner>
  <app-social-bar></app-social-bar>

  <div class="content-body full">
    <div class="content-body-inner full">
      <!-- About Info -->
      <div class="section-full">
        <div class="section-head m-b20">
          <h2 class="title text-uppercase">Some of My <span class="text-gradient">Creative Works</span></h2>
        </div>
        <div class="clearfix">
          <ul id="masonry" class="dlab-gallery-listing gallery lightgallery row sp40">
            <div *ngFor="let portfolio of portfolios" FxLayoutGap="20px">
              <mat-card class="card" fxLayoutAlign="center center" fxLayout="column">
                <mat-card-title class="card-title text-gradient">
                  {{ portfolio.title }}
                </mat-card-title>
                <img class="card-image" mat-card-image [src]="'../../../assets/images/gallery/' + portfolio.image"
                  [alt]="portfolio.title">
                <mat-card-content class="card-content">
                  <button mat-button  class="card-btn">
                    <a [href]="portfolio.link" target="_blank">
                      <i class="fas fa-external-link-alt icons"></i>
                    </a>
                  </button>
                  <br>
                  <br>
                  <div fxLayoutAlign="start start" fxLayout="column">
                    <div class="height100 card-content-subtitle text-gradient" fxLayoutAlign="center center">
                      Description
                    </div>
                    <div class="card-content-description" fxLayoutAlign="center center">{{ portfolio.description }}</div>
                    <br>
                    <div class="height100 card-content-subtitle text-gradient" fxLayoutAlign="center center">
                      Front-End
                    </div>
                    <button mat-button class="card-btn">
                      <a [href]="portfolio.frontEnd.github" target="_blank">
                        <i class="fab fa-github icons"></i>
                      </a>
                    </button>
                    <div>Technologies :</div>
                    <div class="height100" fxLayoutAlign="end center"
                      *ngFor="let technology of portfolio.frontEnd.technologies">{{ technology }}</div>
                    <div>Features :</div>
                    <div class="height100" fxLayoutAlign="end center"
                      *ngFor="let feature of portfolio.frontEnd.features">{{ feature }}</div>
                    <br>
                    <div class="height100 card-content-subtitle text-gradient" fxLayoutAlign="center center">
                      Back-End
                    </div>
                    <button mat-button class="card-btn">
                      <a [href]="portfolio.backEnd.github" target="_blank">
                        <i class="fab fa-github icons"></i>
                      </a>
                    </button>
                    <div>Technologies :</div>
                    <div class="height100" fxLayoutAlign="end center"
                      *ngFor="let technology of portfolio.backEnd.technologies">{{ technology }}</div>
                    <div>Features :</div>
                    <div class="height100" fxLayoutAlign="end center"
                      *ngFor="let feature of portfolio.backEnd.features">{{ feature }}</div>
                  </div>
                </mat-card-content>
                <mat-card-actions class="card-actions">

                </mat-card-actions>
              </mat-card>
            </div>
          </ul>
        </div>
      </div>
    </div>
  </div>
</div>
